<section [formGroup]="mainForm">
  <mbs-form-group>
    <mbs-switcher
      formControlName="overwriteExisting"
      (afterUpdate)="overwriteExistingChangeHandler()"
      [boldLabel]="false"
      [descriptionOutside]="false"
      [label]="(isDatabase ? 'wizards:destinationOld.destOverwriteDBLabel' : 'wizards:destinationOld.destOverwriteVMLabel') | i18next"
      [id]="'overwrite-existing-inner-switcher'">
      <ng-template
        switcherDescription
        [hide]="!isProxmox">
        {{ 'wizards:destinationOld.destOverwriteVMLabelDesc' | i18next }}
      </ng-template>
    </mbs-switcher>
  </mbs-form-group>

  <mbs-table-grid
    class="mb-3"
    id="destination-inner-table"
    listType="table"
    [data]="listItems"
    [disableViewSwitch]="true"
    [headers]="headers"
    [selectable]="false"
    [loading]="loadingTableData"
    [maxHeight]="isDatabase ? '238px' : '286px'"
    [showHeaders]="true"
    [switcherView]="false">
    <ng-template
      mbsTableCell
      let-item
      >{{ item.name }}</ng-template
    >

    <ng-template
      mbsTableCell
      let-item
      let-index="rowIndex">
      <div class="form-row align-items-center">
        <div
          class="col-10"
          formArrayName="specificList">
          <mbs-select
            (change)="specificChangeHandler($event, item)"
            [formControlName]="index.toString()"
            [appendTo]="'.modal-content'"
            [bindValue]="'value'"
            [bindLabel]="'label'"
            [isAutoWidth]="true"
            [clearable]="false"
            [searchable]="false"
            [dropdownPosition]="'auto'"
            [id]="'specific-item-select' + item.id"
            [items]="itemForSelectsData[item.id]"
            [textOverflow]="false">
            <ng-template
              #mbsSelectOptionTmp
              let-part="item">
              <div class="form-row">
                <div class="col overflow-hidden">
                  <mbs-text-ellipsis
                    placement="top-left auto"
                    tooltipClass="tooltip-lg"
                    [tooltip]="part.isSelected ? tooltipData : part.label">
                    {{ part.label }}
                  </mbs-text-ellipsis>
                  <ng-template #tooltipData>
                    <span class="d-block text-start">
                      {{ part.label }}<br />
                      {{ (isDatabase ? 'wizards:databaseSelectedTooltip' : 'wizards:machineSelectedTooltip') | i18next }}
                    </span>
                  </ng-template>
                </div>
                <div
                  *ngIf="part.isSelected"
                  class="col-auto">
                  <span class="ico ico-ok text-gray-500"></span>
                </div>
              </div>
            </ng-template>
          </mbs-select>
        </div>
        <div class="col-2">
          <mbs-button
            icon="fa fa-pencil"
            [container]="'body'"
            [ngbTooltip]="textsMap.editBtnTooltip"
            (click)="editItemName(item, index)"></mbs-button>
        </div>
      </div>
    </ng-template>
  </mbs-table-grid>

  <mbs-alert
    *ngIf="mainForm.get('specificList')?.dirty && mainForm.get('specificList')?.errors?.isAllRequired"
    class="mb-0 mt-3"
    [attr.data-e2e]="elementsSelector.name.isAllRequired"
    [type]="mbsPopupType.warning"
    [icon]="true">
    {{ (isDatabase ? 'wizards:destinationOld.destAllRequiredDBAlert' : 'wizards:destinationOld.destAllRequiredAlert') | i18next }}
  </mbs-alert>

  <mbs-alert
    *ngIf="mainForm.get('specificList')?.dirty && mainForm.get('specificList')?.errors?.isNotUniq"
    [attr.data-e2e]="elementsSelector.name.isNotUniq"
    class="mb-0 mt-3"
    [type]="mbsPopupType.warning"
    [icon]="true">
    {{ 'wizards:mustBeUniqueAlert' | i18next }}
  </mbs-alert>

  <mbs-alert
    *ngIf="mainForm.get('specificList')?.dirty && mainForm.get('specificList')?.errors?.needOverwrite"
    class="mb-0 mt-3"
    [attr.data-e2e]="elementsSelector.name.needOverwrite"
    [type]="mbsPopupType.warning"
    [icon]="true">
    {{ (isDatabase ? 'wizards:needOverwriteDBAlert' : 'wizards:needOverwriteAlert') | i18next }}
  </mbs-alert>
</section>

<ng-template #changeNameModal>
  <div [formGroup]="changeNameForm">
    <p>{{ textsMap.editNameDescription }}</p>
    <mbs-input
      formControlName="restoreAsName"
      name="restoreAsName"
      [label]="textsMap.editNameLabel"
      [id]="'item-name-input'"
      [validationWhitespace]="true"></mbs-input>
  </div>
</ng-template>
